import moment from 'moment'

class Clock {
  now () {
    return moment()
  }
}

export { Clock }
